import { CountriesContext } from '@percent/grants-nomination-form/context/countries/CountriesContext';
import { useContext } from 'react';

export const useCountries = () => {
  const context = useContext(CountriesContext);

  if (context === undefined) {
    throw new Error('useCountries must be used within countriesContextController');
  }

  return context;
};
